<mat-sidenav-container class="sidenav-container overflow-hidden">
  <mat-sidenav-content fxLayout="column" fxFlex="1 1" class="mat-app-background-1">    

    <div fxFlex="51px" class="desktop-only"></div> 
    <app-header fxFlex="24px" class="desktop-only"/>            
    <div fxFlex="43px" class="desktop-only" ></div> 
    
    <div fxFlex="40px" class="mobile-only" ></div> 
    <app-header fxFlex="65px" class="mobile-only"/> 
    <div fxFlex="20px" class="mobile-only"></div> 
    

    <span fxLayout="column" fxFlex="1 1" class="overflow-hidden">
      <ng-content></ng-content>
    </span>
    <app-footer fxFlex="0 0 242px" *ngIf="showFooter"></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
